module.exports = "pegasus_template/assets/theme2/facebook-icon-1.png";